class MobileMenu {

    constructor() {
        this.addListeners()
    }

    addListeners() {
        const btn = document.getElementById('burger');
        

        if (btn) {
            const close = document.getElementById('closeButton');
            const menu = document.getElementById('menuOverlay');

            close.addEventListener('click', () => {
                menu.classList.remove('menu-overlay--active')
            })
            btn.addEventListener('click', () => {                
                menu.classList.add('menu-overlay--active')
            })

            document.addEventListener('keyup', (event) => {
                if (event.keyCode == 27) {
                    menu.classList.remove('menu-overlay--active')
                  }
            });
        }
    }
    
}

export default MobileMenu